import { z } from "zod";

// "unknown" is an FE-only sentinel for lifecycle values this build doesn't
// know (a newer backend mid-rollout, e.g. a future `failed` work-paper
// state). It must read as TERMINAL/degraded, never as "processing": the old
// `.catch("processing")` on `testsState` turned every unknown value into a
// permanent spinner with both 5s pollers running for the rest of the page's
// life (MS-3366). Every procedure-session / sample lifecycle field — the
// status endpoint, the control-session envelope, the table shell and the
// source-row schemas — parses through these two schemas so one unrecognized
// value degrades to "unknown" on every path instead of throwing on some and
// spinning on others.
export const lifecycleStateSchema = z
  .enum(["pending", "processing", "ready", "unknown"])
  .catch("unknown");

export const testsStateSchema = z
  .enum(["pending", "processing", "ready", "retrying", "unknown"])
  .catch("unknown");
